export const API_PATH = '/security/api/v1/user/restoreId'
